import * as React from 'react';

import { sections } from 'components/lexemes';
import { useRouter } from 'next/router';

import { onClickPrivacyPolicyContactUs } from 'containers/events';

import Button from 'components/button/button';
import { Columns } from 'components/columns';
import ColumnsItem, { ColumnsSize } from 'components/columns/columns-item';
import { CtaBox, CtaBoxActions, CtaBoxHeader, CtaBoxText } from 'components/cta-box';
import GoodToKnow from 'components/good-to-know/good-to-know';
import PageSection from 'components/page/page-section';
import { SectionContentLinkListIdEight } from 'components/section-content-link-list';
import { FormattedText, Header2, P1 } from 'components/typography';

export const LandingBlockOneContainer: React.FC = () => {
  const router = useRouter();
  const props = {
    title: sections.aboutSection.lxPagePrivacyPolicyAboutSectionLeftColumnTitle(),
    text: (
      <FormattedText>
        <P1 html={sections.aboutSection.lxPagePrivacyPolicyAboutSectionLeftColumnText1()} as="p" />
        <P1 html={sections.aboutSection.lxPagePrivacyPolicyAboutSectionLeftColumnText2()} as="p" />
        <P1 html={sections.aboutSection.lxPagePrivacyPolicyAboutSectionLeftColumnText3()} as="p" />
      </FormattedText>
    ),
    actionText: sections.aboutSection.lxPagePrivacyPolicyAboutSectionLeftColumnCTA(),
    // actionUrl: `#${TabIdList.ContactUs}`,
    handleActionOnClick: (event: React.MouseEvent) => {
      /**
       * We ignore actionUrl
       */
      event.preventDefault();
      const route = `#${SectionContentLinkListIdEight.OurContactInformation}`;
      router.push(route, undefined, { shallow: true });
      return onClickPrivacyPolicyContactUs();
    },
  };

  return (
    <PageSection color="orange" padding="block" inner={true}>
      <Columns hasMobileLayout={true}>
        <ColumnsItem size={ColumnsSize['1/2']}>
          <CtaBox align="start">
            <CtaBoxHeader tag="div">
              <Header2 as="h2">{props.title}</Header2>
            </CtaBoxHeader>

            <CtaBoxText>{props.text}</CtaBoxText>

            <CtaBoxActions align="start">
              <Button
                // href={props.actionUrl}
                onClick={props.handleActionOnClick}
                text={props.actionText}
              />
            </CtaBoxActions>
          </CtaBox>
        </ColumnsItem>
        <ColumnsItem verticalAlign="stretch" size={ColumnsSize['1/2']}>
          <GoodToKnow
            title={sections.aboutSection.lxPagePrivacyPolicyAboutSectionRightColumnTitle()}
            content={sections.aboutSection.lxPagePrivacyPolicyAboutSectionRightColumnText()}
          />
        </ColumnsItem>
      </Columns>
    </PageSection>
  );
};
